import styles from "./styles.module.scss";
import React from "react";

export default function SegmentGroup({
  segments,
  onSegmentClick,
  currentSegment,
  onEditClick,
  selectedRange,
  currentPlayingSegment,
  onSegmentDoubleClick,
  stopEditing,
}) {
  const isSegmentSelected = (segment) => {
    if (selectedRange.start && selectedRange.end) {
      const startIndex = segments.findIndex(
        (s) => s.id === selectedRange.start.id
      );
      const endIndex = segments.findIndex((s) => s.id === selectedRange.end.id);
      const currentIndex = segments.findIndex((s) => s.id === segment.id);
      return (
        currentIndex >= Math.min(startIndex, endIndex) &&
        currentIndex <= Math.max(startIndex, endIndex)
      );
    }
    return false;
  };

  const shouldShowEditIcon = (segment) => {
    if (selectedRange.start && !selectedRange.end) {
      return segment.id === selectedRange.start.id;
    } else if (selectedRange.start && selectedRange.end) {
      return segment.id === selectedRange.end.id;
    }
    return false;
  };

  function renderWithLineBreaks(text) {
    return text.split("\n").map((str, index, array) =>
      index === array.length - 1 ? (
        str
      ) : (
        <React.Fragment key={index}>
          {str}
          <br />
        </React.Fragment>
      )
    );
  }

  return (
    <div className={styles.segmentGroup}>
      <h4>{segments[0].speaker}: </h4>
      <div>
        {segments.map((segment, index) => (
          <span
            id={`segment-${segment.id}`}
            key={index + "-id"}
            className={`${styles.chunkWrapper} ${
              currentSegment?.id === segment.id || isSegmentSelected(segment)
                ? styles.selected
                : currentPlayingSegment === segment.id
                ? styles.playing
                : ""
            }`}
          >
            <span
              className={`${styles.chunk} ${
                currentSegment?.id === segment.id || isSegmentSelected(segment)
                  ? styles.selected
                  : currentPlayingSegment === segment.id
                  ? styles.playing
                  : ""
              }`}
              onClick={
                stopEditing
                  ? () => {}
                  : (e) => {
                      e.preventDefault();
                      onSegmentClick(segment, e);
                    }
              }
              onDoubleClick={(e) => {
                e.preventDefault();
                onSegmentDoubleClick(segment.start);
              }}
            >
              {renderWithLineBreaks(segment.text)}
            </span>
            {shouldShowEditIcon(segment) && !stopEditing && (
              <img
                src={"/icons/blue-edit.svg"}
                alt="edit"
                className={styles.image}
                onClick={(e) => {
                  e.preventDefault();
                  onEditClick(segment);
                }}
              />
            )}
          </span>
        ))}
      </div>
    </div>
  );
}
